import { ExportDataActionRef } from 'pbts/c1/api/exportdata/v1/exportdata'
import { ExportDataServiceClient } from 'pbts/c1/api/exportdata/v1/exportdata.client'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createMutationApi } from './lib/createMutationApi'

export const exportDataApi = createMutationApi(
    ExportDataServiceClient,
    'exportData',
)

export const exportDataActionsListApi = createPagedListApi(
    ExportDataServiceClient,
    'list',
    undefined,
    ExportDataActionRef.typeName,
)
